(() => {
  const main = document.querySelector('#MainContent');
  if (!(main instanceof HTMLElement) || document.documentElement.dataset.daoPrestigeReady === 'true') return;
  if (main.dataset.template === 'index') return;

  document.documentElement.dataset.daoPrestigeReady = 'true';
  document.documentElement.classList.add('dao-prestige-ready');

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const progress = document.createElement('div');
  progress.className = 'dao-prestige-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.append(progress);

  let scrollTicking = false;
  const updateScroll = () => {
    scrollTicking = false;
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const value = Math.max(0, Math.min(1, window.scrollY / max));
    document.documentElement.style.setProperty('--dao-prestige-scroll', value.toFixed(4));
  };

  updateScroll();
  window.addEventListener('scroll', () => {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(updateScroll);
  }, { passive: true });

  const revealSelectors = [
    '.dao-collection-hero__inner > *',
    '.dao-collection-nav',
    'product-card',
    '.product-information__media',
    '.product-details > .group-block',
    '.dao-product-detail-image__frame',
    '.dao-policy-page__intro',
    '.dao-policy-page__grid > div',
    '.dao-contact-page .contact-form',
    '.dao-notes-page .blog-post-item'
  ];

  const revealItems = [...main.querySelectorAll(revealSelectors.join(','))]
    .filter((item, index, list) => item instanceof HTMLElement && list.indexOf(item) === index)
    .filter((item) => item.getBoundingClientRect().height > 0);

  document.documentElement.dataset.daoPrestigeAnimated = 'true';

  revealItems.forEach((item, index) => {
    item.classList.add('dao-prestige-reveal');
    item.style.setProperty('--dao-prestige-delay', `${Math.min(index % 6, 5) * 70}ms`);
  });

  const revealVisibleItems = () => {
    revealItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight * 1.06 && rect.bottom > -80) {
        item.classList.add('dao-prestige-in');
      }
    });
  };

  if (prefersReduced || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('dao-prestige-in'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dao-prestige-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    revealItems.forEach((item) => observer.observe(item));
    window.requestAnimationFrame(revealVisibleItems);
    window.setTimeout(revealVisibleItems, 450);
  }

  const prestigeCards = [
    ...main.querySelectorAll([
      '.featured-blog-posts-card',
      'product-card .product-card__content',
      '.product-media-container',
      '.product-details > .group-block',
      '.dao-policy-page__grid > div',
      '.dao-contact-page .contact-form',
      '.dao-notes-page .blog-post-item'
    ].join(','))
  ].filter((item) => item instanceof HTMLElement);

  prestigeCards.forEach((card) => card.classList.add('dao-prestige-card'));

  if (!prefersReduced) {
    main.addEventListener('pointermove', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const card = target.closest('.dao-prestige-card');
      if (!(card instanceof HTMLElement)) return;
      const rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      card.style.setProperty('--dao-prestige-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
      card.style.setProperty('--dao-prestige-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
    }, { passive: true });
  }

})();
